import { useMutation } from '@tanstack/react-query';
import type { ChangePasswordRequest } from '@klaro7/shared-types';

import {
  updateProfile,
  changePassword,
  uploadAvatar,
  type UpdateProfilePayload,
} from '../services/profile.service';

export function useUpdateProfile() {
  return useMutation({
    mutationFn: (data: UpdateProfilePayload) => updateProfile(data),
  });
}

export function useUploadAvatar() {
  return useMutation({
    mutationFn: (file: File) => uploadAvatar(file),
  });
}

export function useChangePassword() {
  return useMutation({
    mutationFn: (data: ChangePasswordRequest) => changePassword(data),
  });
}
